export default {
  getDeviceList (state) {
    return state.deviceList;
  },
};